/* eslint-disable no-unused-vars */

import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectRmaInventoryState = (state: RootState) => state.rmaInventory;

const selectRmaInverntoryItems = createSelector(
  selectRmaInventoryState,
  (state) => state.rmaInventoryItems
);

const selectIsInventoryLoading = createSelector(
  selectRmaInventoryState,
  (state) => state.isRmaInventoryLoading
);

const selectFilters = createSelector(
  selectRmaInventoryState,
  (state) => state.filters
);

const selectMeta = createSelector(
  selectRmaInventoryState,
  (state) => state.meta
);

export const selectors = {
  selectFilters,
  selectIsInventoryLoading,
  selectMeta,
  selectRmaInverntoryItems
};
